import React from 'react'
import { TableContainer, Row, DetailedDescription } from './ExpStyled'
import ExplanationDiagram from './ExpDiagram'
import { EXPLANATION_TABLE_CONTENT } from './EXP_CONTENT'
import { DESCRIPTION_PROPS } from './interface'

export default function ExplanationTable({ colors }: DESCRIPTION_PROPS) {
  return (
    <TableContainer colors={colors}>
      {EXPLANATION_TABLE_CONTENT.map((item: any, id: any) => (
        <div key={id}>
          <DetailedDescription>
            <h4>{item.Title}</h4>
            <p>{item.Description}</p>
          </DetailedDescription>
          <Row colors={colors}>
            <h4>User</h4>
            <h4>Server</h4>
          </Row>
          <Row colors={colors}>
            <ExplanationDiagram
              explanation_column={item.LeftColumn}
              explanation_border={item.border}
              colors={colors}
            />
            <ExplanationDiagram
              colors={colors}
              explanation_column={item.RightColumn}
              explanation_border={item.border}
            />
          </Row>
        </div>
      ))}
    </TableContainer>
  )
}
